import { User } from '../../interfaces/user';
import Project from '../../interfaces/project';
import { CommitteeApprovalType } from '../committee-approvals/committee-approval-type';

const tempIdCounts = new Map<string, number>();

function makeTempId(prefix: string): string {
  const count = tempIdCounts.get(prefix) ?? 1;
  tempIdCounts.set(prefix, count + 1);
  return `${prefix}:${count}:${Math.random().toString(36).slice(2)}`;
}

export interface CommitteeItem extends CommitteeItemInput {
  id?: string;
  updater?: User;
  creator?: User;
  project?: Project;
  relatedApprovalTypes?: CommitteeApprovalType[]
  created?: string;
  modified?: string;
  tempId?: string;
  saving?: boolean;
  permissions?: boolean;
  extendedPermissions?: boolean;
  __typeName: 'CommitteeItem';
}
export interface CommitteeItemInput {
  name?: string;
  resolution?: string;
  cleared?: boolean;
  committee_approval_type_id?: number;
  related_approval_type_id?: number;
  creator_id?: string;
  updater_id?: string;
  project_id?: string;
  milestone_id?: string;
  is_post_closing?: boolean;
  shouldDelete?: boolean;
  is_legal_note?: boolean;
  is_condition?: boolean;
}
// Departments an Executive/Refresh item is tied to. Falls back to the legacy single
// related_approval_type_id for items saved before the multi-department relations existed.
export function getRelatedApprovalTypeIds(item: CommitteeItem): string[] {
  if (item.relatedApprovalTypes?.length) {
    return item.relatedApprovalTypes.map((type) => `${type.id}`);
  }
  return item.related_approval_type_id ? [`${item.related_approval_type_id}`] : [];
}
export function isRelatedToApprovalType(item: CommitteeItem, approvalTypeId?: number | string): boolean {
  return approvalTypeId !== undefined && approvalTypeId !== null
    && getRelatedApprovalTypeIds(item).includes(`${approvalTypeId}`);
}
interface CommitteeSeed {
  approvalTypeId: number;
  projectId: string;
  relatedId?: number;
  isLegalNote?: boolean;
  isCondition?: boolean;
}
export function createCommitteeItem({
  approvalTypeId,
  projectId,
  relatedId,
  isLegalNote,
  isCondition,
}: CommitteeSeed): CommitteeItem {
  return {
    name: '',
    project_id: projectId,
    is_post_closing: false,
    tempId: makeTempId(`${approvalTypeId}-`),
    shouldDelete: false,
    is_legal_note: !!isLegalNote,
    is_condition: !!isCondition,
    committee_approval_type_id: approvalTypeId,
    related_approval_type_id: relatedId,
    saving: false,
    permissions:true,
    __typeName: 'CommitteeItem',
  };
}
